import {
  Image as ChakraImage,
  ImageProps as ChakraImageProps,
} from '@chakra-ui/react';
import axios from 'axios';
import React from 'react';

interface ImageProps extends ChakraImageProps {}

export const Image: React.FC<ImageProps> = ({ src, ...props }) => {
  const [image, setImage] = React.useState<string>();
  React.useEffect(() => {
    if (src) {
      if (src.startsWith('data:image')) {
        setImage(src);
      } else {
        axios
          .get(src, { responseType: 'blob' })
          .then((res) => res.data)
          .then((buffer) => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve(reader.result);
              };
              reader.onerror = (e) => {
                console.error(e);
                reject('Could not read Image Properly');
              };
              reader.readAsDataURL(buffer);
            });
          })
          .then(setImage);
      }
    }
  }, [src]);
  return <ChakraImage src={image} {...props} />;
};
